import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import {
  FeatureItemFlatNode,
  FeatureItemNode,
  Hierarchy,
  SiteModel
} from 'src/app/models/index';
import { SiteStepperService } from 'src/app/services/index';
import { UploadImageModalComponent } from '../upload-image-modal/upload-image-modal.component';
@Component({
  selector: 'app-upload-image-configuration',
  templateUrl: './upload-image-configuration.component.html',
  styleUrls: ['./upload-image-configuration.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadImageConfigurationComponent
  extends Hierarchy
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('uploadtree') uploadtree;
  @Input() data: any;
  @Input() parentSubject: Subject<any>;
  @Input() siteId: string;
  // siteId: string;
  siteModel: SiteModel;
  selectedEntityName: string;
  selectedEntityRId: any;
  immediateChildNodes: any;
  immediateChildEntites: any;
  constructor(
    private siteStepperService: SiteStepperService,
    private cdRef: ChangeDetectorRef,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit() {
    // this.siteStepperService.getStepperSubject().subscribe(data => {
    //   if (data.selectedIndex === SiteStepperEnum.ClickAndNavigationDetails && !ObjectUtils.isNullOrUndefined(data.siteModel)) {
    //     console.log("CHANGE STEP");
    //   }
    // });

    this.parentSubject.subscribe((event) => {
      // called when the notifyChildren method is
      // called in the parent component
      // const data = event;
      this.data = event;
      this.initData();
    });
  }

  ngAfterViewInit() {
    this.uploadtree.treeControl.expandAll();
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    // needed if child gets re-created (eg on some model changes)
    // note that subsequent subscriptions on the same subject will fail
    // so the parent has to re-create parentSubject on changes
    this.parentSubject.unsubscribe();
  }

  initData() {
    this.dataSource.data = [];
    // const dataPaser = JSON.parse(this.data.layoutNavigationFeatureTreeData);
    // const dataPaser = JSON.parse(this.data);
    if (this.data !== undefined) {
      this.dataSource.data = this.buildFileTree(
        this.data,
        this.dataSource.data,
        null
      );
    }
    this.uploadtree.treeControl.expandAll();
  }

  buildFileTree(
    obj: any,
    nodes: FeatureItemNode[],
    currentSelected: FeatureItemFlatNode
  ): FeatureItemNode[] {
    const node = new FeatureItemNode();
    node.title = obj.title;
    node.id = obj.id;
    node.Id = obj.Id;
    node.nodeId = obj.nodeId;
    node.nodeType = obj.nodeType;
    node.hasAttachment = obj.hasAttachment;
    node.RId = obj.RId;
    node.loadId = obj.loadId;
    if (currentSelected != null && currentSelected.nodeId === obj.nodeId) {
      node.selected = true;
    }
    if (obj.nodes.length > 0) {
      node.nodes = [];
      obj.nodes.forEach((element) => {
        node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
      });
    }
    return nodes.concat(node);
  }

  public featureLeafItemSelectionToggle(node: FeatureItemFlatNode): void {
    // this.setCurrentNode(node);
    // alert('upload tree-hasAttachment:' + node.hasAttachment);
  }
  openUploadImageModal(node: any) {
    const nodeData = node;
    this.selectedEntityName = '';
    this.immediateChildNodes = [];
    this.immediateChildNodes = this.getImmediateChildNodes(nodeData);
    this.immediateChildEntites = this.immediateChildNodes;
    const dialogRef = this.dialog.open(UploadImageModalComponent, {
      width: '70%',
      data: {
        siteId: this.siteId,
        nodeData: node,
        immediateChildNodes: this.immediateChildNodes,
        clickAndNavigateTreeData: this.data
      }
    });
    if (nodeData != null) {
      dialogRef.componentInstance.selectedEntityName = nodeData.title;
      dialogRef.componentInstance.selectedEntityRId = nodeData.Id;
      dialogRef.componentInstance.siteId = this.siteId;
      dialogRef.componentInstance.immediateChildNodes =
        this.immediateChildNodes;
    }

    dialogRef.afterClosed().subscribe((result) => {
      if (result.status === true) {
        // this.dacData = result.data;
      }
    });
  }

  getImmediateChildNodes(node: any) {
    const t = this;
    if (node.nodes) {
      for (let i = 0; i < node.nodes.length; i++) {
        if (node.nodes[i].nodeType === 'VIRTUAL_GROUP') {
          // console.log("Found Virtual Group ...!!");
          t.getImmediateChildNodes(node.nodes[i]);
        } else {
          t.immediateChildNodes.push({
            Title: node.nodes[i].title,
            RId: node.nodes[i].RId,
            nodeId: node.nodes[i].nodeId
          });
        }
      }
    }
    return t.immediateChildNodes;
  }
}
